import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const MARKETPLACEHEROSLIDETEXTBLOCK_LEGACY_FIELD_ORDER = [
  "text"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  marketplaceHeroSlideTextBlockDescriptor: _generatedMarketplaceHeroSlideTextBlockDescriptor,
  marketplaceHeroSlideTextBlockBlocDefinition,
  marketplaceHeroSlideTextBlockDashboardLayout,
  marketplaceHeroSlideTextBlockConfig,
  marketplaceHeroSlideTextBlockResolveConfig,
  marketplaceHeroSlideTextBlockProperties,
} = doodBlockConfig(
  {
    name: "Marketplace hero - Slide text",
    componentType: 'MarketplaceHeroSlideTextBlockComponent',
    category: 'content',
    description: "Marketplace hero - Slide text.",
    keywords: [],
    allowedIn: [
      { bloc: "MarketplaceHeroBlockComponent", slot: "text_slides" },
    ],
    sharedFields: {}
  },

  () => ({
    text: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.marketplace-hero-slide-text.text.label",
        placeholder: "",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.marketplace-hero-slide-text.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.marketplace-hero-slide-text.fieldset.text.label",
            fields: ["text"],
          },
        ],
      },
    ],
  })
);

export function marketplaceHeroSlideTextBlockDescriptor(): IBlockDescriptor;
export function marketplaceHeroSlideTextBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function marketplaceHeroSlideTextBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedMarketplaceHeroSlideTextBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedMarketplaceHeroSlideTextBlockDescriptor, marketplaceHeroSlideTextBlockProperties, fieldOrder);
}

export {
  marketplaceHeroSlideTextBlockBlocDefinition,
  marketplaceHeroSlideTextBlockDashboardLayout,
  marketplaceHeroSlideTextBlockProperties,
  marketplaceHeroSlideTextBlockConfig,
  marketplaceHeroSlideTextBlockResolveConfig,
};

export type MarketplaceHeroSlideTextBlockConfig = typeof marketplaceHeroSlideTextBlockConfig;
